export const DEFAULT_BREADCRUMB_LEVEL = 'info';
